import { stringify } from "querystring";
import AppStore from "../stores/AppStore";
import AppApi from "./AppApi";

export default class MailApi {
  API_URI: string;

  constructor(private api: AppApi, private store: AppStore, URI: string) {
    this.API_URI = URI;
  }

  /**
   * The legacy mail service does not return CORS headers. Its response is not
   * consumed by the app, so use an opaque request to avoid false Axios
   * "Network Error" failures after the service receives an email request.
   */
  private async request(body: Record<string, string>) {
    const uri = `${this.API_URI}${stringify(body)}`;
    return fetch(uri, {
      method: "GET",
      mode: "no-cors",
    });
  }

  // Send
  async sendMail(
    to: string[],
    from: string,
    cc: string[],
    subject: string,
    message: string
  ) {
    const body = {
      from: from,
      to: to.join(", "),
      cc: to.join(", "),
      subject,
      message,
    };

    return this.request(body);
  }

  async scorecardMail(
    to: string,
    from: string,
    subject: string,
    message: string
  ) {
    const body = {
      from: from,
      to: to,
      subject,
      message,
    };

    return this.request(body);
  }

  async sendMailCC(
    to: string[],
    cc: string[],
    from: string,
    subject: string,
    message: string
  ) {
    const body = {
      from: from,
      to: to.join(", "),
      cc: cc.join(", "),
      subject,
      message,
    };

    return this.request(body);
  }
}
